import React from "react";
import BaseMessage from "./BaseMessage";

export default function Info(props) {
  return <BaseMessage {...props} type={"success"} />
}